import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/gpu/x2.png'
import _imports_1 from '@/assets/2x/gpu/x2.png'
import _imports_2 from '@/assets/gpu/x4.png'
import _imports_3 from '@/assets/2x/gpu/x4.png'
import _imports_4 from '@/assets/gpu/x8.png'
import _imports_5 from '@/assets/2x/gpu/x8.png'
import _imports_6 from '@/assets/gpu/x16.png'
import _imports_7 from '@/assets/2x/gpu/x16.png'
import _imports_8 from '@/assets/gpu/x32.png'
import _imports_9 from '@/assets/2x/gpu/x32.png'
import _imports_10 from '@/assets/gpu/x64.png'
import _imports_11 from '@/assets/2x/gpu/x64.png'
import _imports_12 from '@/assets/gpu/x128.png'
import _imports_13 from '@/assets/2x/gpu/x128.png'
import _imports_14 from '@/assets/gpu/x256.png'
import _imports_15 from '@/assets/2x/gpu/x256.png'
import _imports_16 from '@/assets/gpu/x512.png'
import _imports_17 from '@/assets/2x/gpu/x512.png'
import _imports_18 from '@/assets/gpu/x1024.png'
import _imports_19 from '@/assets/2x/gpu/x1024.png'
import _imports_20 from '@/assets/gpu/x2048.png'
import _imports_21 from '@/assets/2x/gpu/x2048.png'
import _imports_22 from '@/assets/ram/x2.png'
import _imports_23 from '@/assets/2x/ram/x2.png'
import _imports_24 from '@/assets/ram/x4.png'
import _imports_25 from '@/assets/2x/ram/x4.png'
import _imports_26 from '@/assets/ram/x8.png'
import _imports_27 from '@/assets/2x/ram/x8.png'
import _imports_28 from '@/assets/ram/x16.png'
import _imports_29 from '@/assets/2x/ram/x16.png'
import _imports_30 from '@/assets/ram/x32.png'
import _imports_31 from '@/assets/2x/ram/x32.png'
import _imports_32 from '@/assets/ram/x64.png'
import _imports_33 from '@/assets/2x/ram/x64.png'
import _imports_34 from '@/assets/ram/x128.png'
import _imports_35 from '@/assets/2x/ram/x128.png'
import _imports_36 from '@/assets/ram/x256.png'
import _imports_37 from '@/assets/2x/ram/x256.png'
import _imports_38 from '@/assets/ram/x512.png'
import _imports_39 from '@/assets/2x/ram/x512.png'
import _imports_40 from '@/assets/ram/x1024.png'
import _imports_41 from '@/assets/2x/ram/x1024.png'
import _imports_42 from '@/assets/ram/x2048.png'
import _imports_43 from '@/assets/2x/ram/x2048.png'
import _imports_44 from '@/assets/cpu/x2.png'
import _imports_45 from '@/assets/2x/cpu/x2.png'
import _imports_46 from '@/assets/cpu/x4.png'
import _imports_47 from '@/assets/2x/cpu/x4.png'
import _imports_48 from '@/assets/cpu/x8.png'
import _imports_49 from '@/assets/2x/cpu/x8.png'
import _imports_50 from '@/assets/cpu/x16.png'
import _imports_51 from '@/assets/2x/cpu/x16.png'
import _imports_52 from '@/assets/cpu/x32.png'
import _imports_53 from '@/assets/2x/cpu/x32.png'
import _imports_54 from '@/assets/cpu/x64.png'
import _imports_55 from '@/assets/2x/cpu/x64.png'
import _imports_56 from '@/assets/cpu/x128.png'
import _imports_57 from '@/assets/2x/cpu/x128.png'
import _imports_58 from '@/assets/cpu/x256.png'
import _imports_59 from '@/assets/2x/cpu/x256.png'
import _imports_60 from '@/assets/cpu/x512.png'
import _imports_61 from '@/assets/2x/cpu/x512.png'
import _imports_62 from '@/assets/cpu/x1024.png'
import _imports_63 from '@/assets/2x/cpu/x1024.png'
import _imports_64 from '@/assets/cpu/x2048.png'
import _imports_65 from '@/assets/2x/cpu/x2048.png'
import _imports_66 from '@/assets/hdd/x2.png'
import _imports_67 from '@/assets/2x/hdd/x2.png'
import _imports_68 from '@/assets/hdd/x4.png'
import _imports_69 from '@/assets/2x/hdd/x4.png'
import _imports_70 from '@/assets/hdd/x8.png'
import _imports_71 from '@/assets/2x/hdd/x8.png'
import _imports_72 from '@/assets/hdd/x16.png'
import _imports_73 from '@/assets/2x/hdd/x16.png'
import _imports_74 from '@/assets/hdd/x32.png'
import _imports_75 from '@/assets/2x/hdd/x32.png'
import _imports_76 from '@/assets/hdd/x64.png'
import _imports_77 from '@/assets/2x/hdd/x64.png'
import _imports_78 from '@/assets/hdd/x128.png'
import _imports_79 from '@/assets/2x/hdd/x128.png'
import _imports_80 from '@/assets/hdd/x256.png'
import _imports_81 from '@/assets/2x/hdd/x256.png'
import _imports_82 from '@/assets/hdd/x512.png'
import _imports_83 from '@/assets/2x/hdd/x512.png'
import _imports_84 from '@/assets/hdd/x1024.png'
import _imports_85 from '@/assets/2x/hdd/x1024.png'
import _imports_86 from '@/assets/hdd/x2048.png'
import _imports_87 from '@/assets/2x/hdd/x2048.png'


const _withScopeId = n => (_pushScopeId("data-v-4ff531a4"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tile__border" }, null, -1))
const _hoisted_2 = {
  key: 1,
  class: "tile__active-badge"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_tp_tile_blur_absolute = _resolveComponent("tp-tile-blur-absolute")!
  const _component_tp_tile_blur = _resolveComponent("tp-tile-blur")!
  const _component_tp_done = _resolveComponent("tp-done")!

  return (_ctx.value !== 0)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(_ctx.classes)
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.tileClasses(_ctx.value, _ctx.type))
        }, [
          _createElementVNode("span", {
            class: _normalizeClass(_ctx.getTileValueClasses())
          }, _toDisplayString(_ctx.value), 3),
          (_ctx.isImageVisible(0, 2, _ctx.types.gpu) && _ctx.isAbsolute)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: _imports_0,
                class: _normalizeClass(_ctx.tileImageClasses(_ctx.value, _ctx.type))
              }, null, 2))
            : _createCommentVNode("", true),
          (_ctx.isImageVisible(0, 2, _ctx.types.gpu) && !_ctx.isAbsolute)
            ? (_openBlock(), _createElementBlock("img", {
                key: 1,
                src: _imports_1,
                class: _normalizeClass(_ctx.tileImageClasses(_ctx.value, _ctx.type))
              }, null, 2))
            : _createCommentVNode("", true),
          (_ctx.isImageVisible(2, 4, _ctx.types.gpu) && _ctx.isAbsolute)
            ? (_openBlock(), _createElementBlock("img", {
                key: 2,
                src: _imports_2,
                class: _normalizeClass(_ctx.tileImageClasses(_ctx.value, _ctx.type))
              }, null, 2))
            : _createCommentVNode("", true),
          (_ctx.isImageVisible(2, 4, _ctx.types.gpu) && !_ctx.isAbsolute)
            ? (_openBlock(), _createElementBlock("img", {
                key: 3,
                src: _imports_3,
                class: _normalizeClass(_ctx.tileImageClasses(_ctx.value, _ctx.type))
              }, null, 2))
            : _createCommentVNode("", true),
          (_ctx.isImageVisible(4, 8, _ctx.types.gpu) && _ctx.isAbsolute)
            ? (_openBlock(), _createElementBlock("img", {
                key: 4,
                src: _imports_4,
                class: _normalizeClass(_ctx.tileImageClasses(_ctx.value, _ctx.type))
              }, null, 2))
            : _createCommentVNode("", true),
          (_ctx.isImageVisible(4, 8, _ctx.types.gpu) && !_ctx.isAbsolute)
            ? (_openBlock(), _createElementBlock("img", {
                key: 5,
                src: _imports_5,
                class: _normalizeClass(_ctx.tileImageClasses(_ctx.value, _ctx.type))
              }, null, 2))
            : _createCommentVNode("", true),
          (_ctx.isImageVisible(8, 16, _ctx.types.gpu) && _ctx.isAbsolute)
            ? (_openBlock(), _createElementBlock("img", {
                key: 6,
                src: _imports_6,
                class: _normalizeClass(_ctx.tileImageClasses(_ctx.value, _ctx.type))
              }, null, 2))
            : _createCommentVNode("", true),
          (_ctx.isImageVisible(8, 16, _ctx.types.gpu) && !_ctx.isAbsolute)
            ? (_openBlock(), _createElementBlock("img", {
                key: 7,
                src: _imports_7,
                class: _normalizeClass(_ctx.tileImageClasses(_ctx.value, _ctx.type))
              }, null, 2))
            : _createCommentVNode("", true),
          (_ctx.isImageVisible(16, 32, _ctx.types.gpu) && _ctx.isAbsolute)
            ? (_openBlock(), _createElementBlock("img", {
                key: 8,
                src: _imports_8,
                class: _normalizeClass(_ctx.tileImageClasses(_ctx.value, _ctx.type))
              }, null, 2))
            : _createCommentVNode("", true),
          (_ctx.isImageVisible(16, 32, _ctx.types.gpu) && !_ctx.isAbsolute)
            ? (_openBlock(), _createElementBlock("img", {
                key: 9,
                src: _imports_9,
                class: _normalizeClass(_ctx.tileImageClasses(_ctx.value, _ctx.type))
              }, null, 2))
            : _createCommentVNode("", true),
          (_ctx.isImageVisible(32, 64, _ctx.types.gpu) && _ctx.isAbsolute)
            ? (_openBlock(), _createElementBlock("img", {
                key: 10,
                src: _imports_10,
                class: _normalizeClass(_ctx.tileImageClasses(_ctx.value, _ctx.type))
              }, null, 2))
            : _createCommentVNode("", true),
          (_ctx.isImageVisible(32, 64, _ctx.types.gpu) && !_ctx.isAbsolute)
            ? (_openBlock(), _createElementBlock("img", {
                key: 11,
                src: _imports_11,
                class: _normalizeClass(_ctx.tileImageClasses(_ctx.value, _ctx.type))
              }, null, 2))
            : _createCommentVNode("", true),
          (_ctx.isImageVisible(64, 128, _ctx.types.gpu) && _ctx.isAbsolute)
            ? (_openBlock(), _createElementBlock("img", {
                key: 12,
                src: _imports_12,
                class: _normalizeClass(_ctx.tileImageClasses(_ctx.value, _ctx.type))
              }, null, 2))
            : _createCommentVNode("", true),
          (_ctx.isImageVisible(64, 128, _ctx.types.gpu) && !_ctx.isAbsolute)
            ? (_openBlock(), _createElementBlock("img", {
                key: 13,
                src: _imports_13,
                class: _normalizeClass(_ctx.tileImageClasses(_ctx.value, _ctx.type))
              }, null, 2))
            : _createCommentVNode("", true),
          (_ctx.isImageVisible(128, 256, _ctx.types.gpu) && _ctx.isAbsolute)
            ? (_openBlock(), _createElementBlock("img", {
                key: 14,
                src: _imports_14,
                class: _normalizeClass(_ctx.tileImageClasses(_ctx.value, _ctx.type))
              }, null, 2))
            : _createCommentVNode("", true),
          (_ctx.isImageVisible(128, 256, _ctx.types.gpu) && !_ctx.isAbsolute)
            ? (_openBlock(), _createElementBlock("img", {
                key: 15,
                src: _imports_15,
                class: _normalizeClass(_ctx.tileImageClasses(_ctx.value, _ctx.type))
              }, null, 2))
            : _createCommentVNode("", true),
          (_ctx.isImageVisible(256, 512, _ctx.types.gpu) && _ctx.isAbsolute)
            ? (_openBlock(), _createElementBlock("img", {
                key: 16,
                src: _imports_16,
                class: _normalizeClass(_ctx.tileImageClasses(_ctx.value, _ctx.type))
              }, null, 2))
            : _createCommentVNode("", true),
          (_ctx.isImageVisible(256, 512, _ctx.types.gpu) && !_ctx.isAbsolute)
            ? (_openBlock(), _createElementBlock("img", {
                key: 17,
                src: _imports_17,
                class: _normalizeClass(_ctx.tileImageClasses(_ctx.value, _ctx.type))
              }, null, 2))
            : _createCommentVNode("", true),
          (_ctx.isImageVisible(512, 1024, _ctx.types.gpu) && _ctx.isAbsolute)
            ? (_openBlock(), _createElementBlock("img", {
                key: 18,
                src: _imports_18,
                class: _normalizeClass(_ctx.tileImageClasses(_ctx.value, _ctx.type))
              }, null, 2))
            : _createCommentVNode("", true),
          (_ctx.isImageVisible(512, 1024, _ctx.types.gpu) && !_ctx.isAbsolute)
            ? (_openBlock(), _createElementBlock("img", {
                key: 19,
                src: _imports_19,
                class: _normalizeClass(_ctx.tileImageClasses(_ctx.value, _ctx.type))
              }, null, 2))
            : _createCommentVNode("", true),
          (_ctx.isImageVisible(1024, 2048, _ctx.types.gpu) && _ctx.isAbsolute)
            ? (_openBlock(), _createElementBlock("img", {
                key: 20,
                src: _imports_20,
                class: _normalizeClass(_ctx.tileImageClasses(_ctx.value, _ctx.type))
              }, null, 2))
            : _createCommentVNode("", true),
          (_ctx.isImageVisible(1024, 2048, _ctx.types.gpu) && !_ctx.isAbsolute)
            ? (_openBlock(), _createElementBlock("img", {
                key: 21,
                src: _imports_21,
                class: _normalizeClass(_ctx.tileImageClasses(_ctx.value, _ctx.type))
              }, null, 2))
            : _createCommentVNode("", true),
          (_ctx.isImageVisible(0, 2, _ctx.types.ram) && _ctx.isAbsolute)
            ? (_openBlock(), _createElementBlock("img", {
                key: 22,
                src: _imports_22,
                class: _normalizeClass(_ctx.tileImageClasses(_ctx.value, _ctx.type))
              }, null, 2))
            : _createCommentVNode("", true),
          (_ctx.isImageVisible(0, 2, _ctx.types.ram) && !_ctx.isAbsolute)
            ? (_openBlock(), _createElementBlock("img", {
                key: 23,
                src: _imports_23,
                class: _normalizeClass(_ctx.tileImageClasses(_ctx.value, _ctx.type))
              }, null, 2))
            : _createCommentVNode("", true),
          (_ctx.isImageVisible(2, 4, _ctx.types.ram) && _ctx.isAbsolute)
            ? (_openBlock(), _createElementBlock("img", {
                key: 24,
                src: _imports_24,
                class: _normalizeClass(_ctx.tileImageClasses(_ctx.value, _ctx.type))
              }, null, 2))
            : _createCommentVNode("", true),
          (_ctx.isImageVisible(2, 4, _ctx.types.ram) && !_ctx.isAbsolute)
            ? (_openBlock(), _createElementBlock("img", {
                key: 25,
                src: _imports_25,
                class: _normalizeClass(_ctx.tileImageClasses(_ctx.value, _ctx.type))
              }, null, 2))
            : _createCommentVNode("", true),
          (_ctx.isImageVisible(4, 8, _ctx.types.ram) && _ctx.isAbsolute)
            ? (_openBlock(), _createElementBlock("img", {
                key: 26,
                src: _imports_26,
                class: _normalizeClass(_ctx.tileImageClasses(_ctx.value, _ctx.type))
              }, null, 2))
            : _createCommentVNode("", true),
          (_ctx.isImageVisible(4, 8, _ctx.types.ram) && !_ctx.isAbsolute)
            ? (_openBlock(), _createElementBlock("img", {
                key: 27,
                src: _imports_27,
                class: _normalizeClass(_ctx.tileImageClasses(_ctx.value, _ctx.type))
              }, null, 2))
            : _createCommentVNode("", true),
          (_ctx.isImageVisible(8, 16, _ctx.types.ram) && _ctx.isAbsolute)
            ? (_openBlock(), _createElementBlock("img", {
                key: 28,
                src: _imports_28,
                class: _normalizeClass(_ctx.tileImageClasses(_ctx.value, _ctx.type))
              }, null, 2))
            : _createCommentVNode("", true),
          (_ctx.isImageVisible(8, 16, _ctx.types.ram) && !_ctx.isAbsolute)
            ? (_openBlock(), _createElementBlock("img", {
                key: 29,
                src: _imports_29,
                class: _normalizeClass(_ctx.tileImageClasses(_ctx.value, _ctx.type))
              }, null, 2))
            : _createCommentVNode("", true),
          (_ctx.isImageVisible(16, 32, _ctx.types.ram) && _ctx.isAbsolute)
            ? (_openBlock(), _createElementBlock("img", {
                key: 30,
                src: _imports_30,
                class: _normalizeClass(_ctx.tileImageClasses(_ctx.value, _ctx.type))
              }, null, 2))
            : _createCommentVNode("", true),
          (_ctx.isImageVisible(16, 32, _ctx.types.ram) && !_ctx.isAbsolute)
            ? (_openBlock(), _createElementBlock("img", {
                key: 31,
                src: _imports_31,
                class: _normalizeClass(_ctx.tileImageClasses(_ctx.value, _ctx.type))
              }, null, 2))
            : _createCommentVNode("", true),
          (_ctx.isImageVisible(32, 64, _ctx.types.ram) && _ctx.isAbsolute)
            ? (_openBlock(), _createElementBlock("img", {
                key: 32,
                src: _imports_32,
                class: _normalizeClass(_ctx.tileImageClasses(_ctx.value, _ctx.type))
              }, null, 2))
            : _createCommentVNode("", true),
          (_ctx.isImageVisible(32, 64, _ctx.types.ram) && !_ctx.isAbsolute)
            ? (_openBlock(), _createElementBlock("img", {
                key: 33,
                src: _imports_33,
                class: _normalizeClass(_ctx.tileImageClasses(_ctx.value, _ctx.type))
              }, null, 2))
            : _createCommentVNode("", true),
          (_ctx.isImageVisible(64, 128, _ctx.types.ram) && _ctx.isAbsolute)
            ? (_openBlock(), _createElementBlock("img", {
                key: 34,
                src: _imports_34,
                class: _normalizeClass(_ctx.tileImageClasses(_ctx.value, _ctx.type))
              }, null, 2))
            : _createCommentVNode("", true),
          (_ctx.isImageVisible(64, 128, _ctx.types.ram) && !_ctx.isAbsolute)
            ? (_openBlock(), _createElementBlock("img", {
                key: 35,
                src: _imports_35,
                class: _normalizeClass(_ctx.tileImageClasses(_ctx.value, _ctx.type))
              }, null, 2))
            : _createCommentVNode("", true),
          (_ctx.isImageVisible(128, 256, _ctx.types.ram) && _ctx.isAbsolute)
            ? (_openBlock(), _createElementBlock("img", {
                key: 36,
                src: _imports_36,
                class: _normalizeClass(_ctx.tileImageClasses(_ctx.value, _ctx.type))
              }, null, 2))
            : _createCommentVNode("", true),
          (_ctx.isImageVisible(128, 256, _ctx.types.ram) && !_ctx.isAbsolute)
            ? (_openBlock(), _createElementBlock("img", {
                key: 37,
                src: _imports_37,
                class: _normalizeClass(_ctx.tileImageClasses(_ctx.value, _ctx.type))
              }, null, 2))
            : _createCommentVNode("", true),
          (_ctx.isImageVisible(256, 512, _ctx.types.ram) && _ctx.isAbsolute)
            ? (_openBlock(), _createElementBlock("img", {
                key: 38,
                src: _imports_38,
                class: _normalizeClass(_ctx.tileImageClasses(_ctx.value, _ctx.type))
              }, null, 2))
            : _createCommentVNode("", true),
          (_ctx.isImageVisible(256, 512, _ctx.types.ram) && !_ctx.isAbsolute)
            ? (_openBlock(), _createElementBlock("img", {
                key: 39,
                src: _imports_39,
                class: _normalizeClass(_ctx.tileImageClasses(_ctx.value, _ctx.type))
              }, null, 2))
            : _createCommentVNode("", true),
          (_ctx.isImageVisible(512, 1024, _ctx.types.ram) && _ctx.isAbsolute)
            ? (_openBlock(), _createElementBlock("img", {
                key: 40,
                src: _imports_40,
                class: _normalizeClass(_ctx.tileImageClasses(_ctx.value, _ctx.type))
              }, null, 2))
            : _createCommentVNode("", true),
          (_ctx.isImageVisible(512, 1024, _ctx.types.ram) && !_ctx.isAbsolute)
            ? (_openBlock(), _createElementBlock("img", {
                key: 41,
                src: _imports_41,
                class: _normalizeClass(_ctx.tileImageClasses(_ctx.value, _ctx.type))
              }, null, 2))
            : _createCommentVNode("", true),
          (_ctx.isImageVisible(1024, 2048, _ctx.types.ram) && _ctx.isAbsolute)
            ? (_openBlock(), _createElementBlock("img", {
                key: 42,
                src: _imports_42,
                class: _normalizeClass(_ctx.tileImageClasses(_ctx.value, _ctx.type))
              }, null, 2))
            : _createCommentVNode("", true),
          (_ctx.isImageVisible(1024, 2048, _ctx.types.ram) && !_ctx.isAbsolute)
            ? (_openBlock(), _createElementBlock("img", {
                key: 43,
                src: _imports_43,
                class: _normalizeClass(_ctx.tileImageClasses(_ctx.value, _ctx.type))
              }, null, 2))
            : _createCommentVNode("", true),
          (_ctx.isImageVisible(0, 2, _ctx.types.cpu) && _ctx.isAbsolute)
            ? (_openBlock(), _createElementBlock("img", {
                key: 44,
                src: _imports_44,
                class: _normalizeClass(_ctx.tileImageClasses(_ctx.value, _ctx.type))
              }, null, 2))
            : _createCommentVNode("", true),
          (_ctx.isImageVisible(0, 2, _ctx.types.cpu) && !_ctx.isAbsolute)
            ? (_openBlock(), _createElementBlock("img", {
                key: 45,
                src: _imports_45,
                class: _normalizeClass(_ctx.tileImageClasses(_ctx.value, _ctx.type))
              }, null, 2))
            : _createCommentVNode("", true),
          (_ctx.isImageVisible(2, 4, _ctx.types.cpu) && _ctx.isAbsolute)
            ? (_openBlock(), _createElementBlock("img", {
                key: 46,
                src: _imports_46,
                class: _normalizeClass(_ctx.tileImageClasses(_ctx.value, _ctx.type))
              }, null, 2))
            : _createCommentVNode("", true),
          (_ctx.isImageVisible(2, 4, _ctx.types.cpu) && !_ctx.isAbsolute)
            ? (_openBlock(), _createElementBlock("img", {
                key: 47,
                src: _imports_47,
                class: _normalizeClass(_ctx.tileImageClasses(_ctx.value, _ctx.type))
              }, null, 2))
            : _createCommentVNode("", true),
          (_ctx.isImageVisible(4, 8, _ctx.types.cpu) && _ctx.isAbsolute)
            ? (_openBlock(), _createElementBlock("img", {
                key: 48,
                src: _imports_48,
                class: _normalizeClass(_ctx.tileImageClasses(_ctx.value, _ctx.type))
              }, null, 2))
            : _createCommentVNode("", true),
          (_ctx.isImageVisible(4, 8, _ctx.types.cpu) && !_ctx.isAbsolute)
            ? (_openBlock(), _createElementBlock("img", {
                key: 49,
                src: _imports_49,
                class: _normalizeClass(_ctx.tileImageClasses(_ctx.value, _ctx.type))
              }, null, 2))
            : _createCommentVNode("", true),
          (_ctx.isImageVisible(8, 16, _ctx.types.cpu) && _ctx.isAbsolute)
            ? (_openBlock(), _createElementBlock("img", {
                key: 50,
                src: _imports_50,
                class: _normalizeClass(_ctx.tileImageClasses(_ctx.value, _ctx.type))
              }, null, 2))
            : _createCommentVNode("", true),
          (_ctx.isImageVisible(8, 16, _ctx.types.cpu) && !_ctx.isAbsolute)
            ? (_openBlock(), _createElementBlock("img", {
                key: 51,
                src: _imports_51,
                class: _normalizeClass(_ctx.tileImageClasses(_ctx.value, _ctx.type))
              }, null, 2))
            : _createCommentVNode("", true),
          (_ctx.isImageVisible(16, 32, _ctx.types.cpu) && _ctx.isAbsolute)
            ? (_openBlock(), _createElementBlock("img", {
                key: 52,
                src: _imports_52,
                class: _normalizeClass(_ctx.tileImageClasses(_ctx.value, _ctx.type))
              }, null, 2))
            : _createCommentVNode("", true),
          (_ctx.isImageVisible(16, 32, _ctx.types.cpu) && !_ctx.isAbsolute)
            ? (_openBlock(), _createElementBlock("img", {
                key: 53,
                src: _imports_53,
                class: _normalizeClass(_ctx.tileImageClasses(_ctx.value, _ctx.type))
              }, null, 2))
            : _createCommentVNode("", true),
          (_ctx.isImageVisible(32, 64, _ctx.types.cpu) && _ctx.isAbsolute)
            ? (_openBlock(), _createElementBlock("img", {
                key: 54,
                src: _imports_54,
                class: _normalizeClass(_ctx.tileImageClasses(_ctx.value, _ctx.type))
              }, null, 2))
            : _createCommentVNode("", true),
          (_ctx.isImageVisible(32, 64, _ctx.types.cpu) && !_ctx.isAbsolute)
            ? (_openBlock(), _createElementBlock("img", {
                key: 55,
                src: _imports_55,
                class: _normalizeClass(_ctx.tileImageClasses(_ctx.value, _ctx.type))
              }, null, 2))
            : _createCommentVNode("", true),
          (_ctx.isImageVisible(64, 128, _ctx.types.cpu) && _ctx.isAbsolute)
            ? (_openBlock(), _createElementBlock("img", {
                key: 56,
                src: _imports_56,
                class: _normalizeClass(_ctx.tileImageClasses(_ctx.value, _ctx.type))
              }, null, 2))
            : _createCommentVNode("", true),
          (_ctx.isImageVisible(64, 128, _ctx.types.cpu) && !_ctx.isAbsolute)
            ? (_openBlock(), _createElementBlock("img", {
                key: 57,
                src: _imports_57,
                class: _normalizeClass(_ctx.tileImageClasses(_ctx.value, _ctx.type))
              }, null, 2))
            : _createCommentVNode("", true),
          (_ctx.isImageVisible(128, 256, _ctx.types.cpu) && _ctx.isAbsolute)
            ? (_openBlock(), _createElementBlock("img", {
                key: 58,
                src: _imports_58,
                class: _normalizeClass(_ctx.tileImageClasses(_ctx.value, _ctx.type))
              }, null, 2))
            : _createCommentVNode("", true),
          (_ctx.isImageVisible(128, 256, _ctx.types.cpu) && !_ctx.isAbsolute)
            ? (_openBlock(), _createElementBlock("img", {
                key: 59,
                src: _imports_59,
                class: _normalizeClass(_ctx.tileImageClasses(_ctx.value, _ctx.type))
              }, null, 2))
            : _createCommentVNode("", true),
          (_ctx.isImageVisible(256, 512, _ctx.types.cpu) && _ctx.isAbsolute)
            ? (_openBlock(), _createElementBlock("img", {
                key: 60,
                src: _imports_60,
                class: _normalizeClass(_ctx.tileImageClasses(_ctx.value, _ctx.type))
              }, null, 2))
            : _createCommentVNode("", true),
          (_ctx.isImageVisible(256, 512, _ctx.types.cpu) && !_ctx.isAbsolute)
            ? (_openBlock(), _createElementBlock("img", {
                key: 61,
                src: _imports_61,
                class: _normalizeClass(_ctx.tileImageClasses(_ctx.value, _ctx.type))
              }, null, 2))
            : _createCommentVNode("", true),
          (_ctx.isImageVisible(512, 1024, _ctx.types.cpu) && _ctx.isAbsolute)
            ? (_openBlock(), _createElementBlock("img", {
                key: 62,
                src: _imports_62,
                class: _normalizeClass(_ctx.tileImageClasses(_ctx.value, _ctx.type))
              }, null, 2))
            : _createCommentVNode("", true),
          (_ctx.isImageVisible(512, 1024, _ctx.types.cpu) && !_ctx.isAbsolute)
            ? (_openBlock(), _createElementBlock("img", {
                key: 63,
                src: _imports_63,
                class: _normalizeClass(_ctx.tileImageClasses(_ctx.value, _ctx.type))
              }, null, 2))
            : _createCommentVNode("", true),
          (_ctx.isImageVisible(1024, 2048, _ctx.types.cpu) && _ctx.isAbsolute)
            ? (_openBlock(), _createElementBlock("img", {
                key: 64,
                src: _imports_64,
                class: _normalizeClass(_ctx.tileImageClasses(_ctx.value, _ctx.type))
              }, null, 2))
            : _createCommentVNode("", true),
          (_ctx.isImageVisible(1024, 2048, _ctx.types.cpu) && !_ctx.isAbsolute)
            ? (_openBlock(), _createElementBlock("img", {
                key: 65,
                src: _imports_65,
                class: _normalizeClass(_ctx.tileImageClasses(_ctx.value, _ctx.type))
              }, null, 2))
            : _createCommentVNode("", true),
          (_ctx.isImageVisible(0, 2, _ctx.types.hdd) && _ctx.isAbsolute)
            ? (_openBlock(), _createElementBlock("img", {
                key: 66,
                src: _imports_66,
                class: _normalizeClass(_ctx.tileImageClasses(_ctx.value, _ctx.type))
              }, null, 2))
            : _createCommentVNode("", true),
          (_ctx.isImageVisible(0, 2, _ctx.types.hdd) && !_ctx.isAbsolute)
            ? (_openBlock(), _createElementBlock("img", {
                key: 67,
                src: _imports_67,
                class: _normalizeClass(_ctx.tileImageClasses(_ctx.value, _ctx.type))
              }, null, 2))
            : _createCommentVNode("", true),
          (_ctx.isImageVisible(2, 4, _ctx.types.hdd) && _ctx.isAbsolute)
            ? (_openBlock(), _createElementBlock("img", {
                key: 68,
                src: _imports_68,
                class: _normalizeClass(_ctx.tileImageClasses(_ctx.value, _ctx.type))
              }, null, 2))
            : _createCommentVNode("", true),
          (_ctx.isImageVisible(2, 4, _ctx.types.hdd) && !_ctx.isAbsolute)
            ? (_openBlock(), _createElementBlock("img", {
                key: 69,
                src: _imports_69,
                class: _normalizeClass(_ctx.tileImageClasses(_ctx.value, _ctx.type))
              }, null, 2))
            : _createCommentVNode("", true),
          (_ctx.isImageVisible(4, 8, _ctx.types.hdd) && _ctx.isAbsolute)
            ? (_openBlock(), _createElementBlock("img", {
                key: 70,
                src: _imports_70,
                class: _normalizeClass(_ctx.tileImageClasses(_ctx.value, _ctx.type))
              }, null, 2))
            : _createCommentVNode("", true),
          (_ctx.isImageVisible(4, 8, _ctx.types.hdd) && !_ctx.isAbsolute)
            ? (_openBlock(), _createElementBlock("img", {
                key: 71,
                src: _imports_71,
                class: _normalizeClass(_ctx.tileImageClasses(_ctx.value, _ctx.type))
              }, null, 2))
            : _createCommentVNode("", true),
          (_ctx.isImageVisible(8, 16, _ctx.types.hdd) && _ctx.isAbsolute)
            ? (_openBlock(), _createElementBlock("img", {
                key: 72,
                src: _imports_72,
                class: _normalizeClass(_ctx.tileImageClasses(_ctx.value, _ctx.type))
              }, null, 2))
            : _createCommentVNode("", true),
          (_ctx.isImageVisible(8, 16, _ctx.types.hdd) && !_ctx.isAbsolute)
            ? (_openBlock(), _createElementBlock("img", {
                key: 73,
                src: _imports_73,
                class: _normalizeClass(_ctx.tileImageClasses(_ctx.value, _ctx.type))
              }, null, 2))
            : _createCommentVNode("", true),
          (_ctx.isImageVisible(16, 32, _ctx.types.hdd) && _ctx.isAbsolute)
            ? (_openBlock(), _createElementBlock("img", {
                key: 74,
                src: _imports_74,
                class: _normalizeClass(_ctx.tileImageClasses(_ctx.value, _ctx.type))
              }, null, 2))
            : _createCommentVNode("", true),
          (_ctx.isImageVisible(16, 32, _ctx.types.hdd) && !_ctx.isAbsolute)
            ? (_openBlock(), _createElementBlock("img", {
                key: 75,
                src: _imports_75,
                class: _normalizeClass(_ctx.tileImageClasses(_ctx.value, _ctx.type))
              }, null, 2))
            : _createCommentVNode("", true),
          (_ctx.isImageVisible(32, 64, _ctx.types.hdd) && _ctx.isAbsolute)
            ? (_openBlock(), _createElementBlock("img", {
                key: 76,
                src: _imports_76,
                class: _normalizeClass(_ctx.tileImageClasses(_ctx.value, _ctx.type))
              }, null, 2))
            : _createCommentVNode("", true),
          (_ctx.isImageVisible(32, 64, _ctx.types.hdd) && !_ctx.isAbsolute)
            ? (_openBlock(), _createElementBlock("img", {
                key: 77,
                src: _imports_77,
                class: _normalizeClass(_ctx.tileImageClasses(_ctx.value, _ctx.type))
              }, null, 2))
            : _createCommentVNode("", true),
          (_ctx.isImageVisible(64, 128, _ctx.types.hdd) && _ctx.isAbsolute)
            ? (_openBlock(), _createElementBlock("img", {
                key: 78,
                src: _imports_78,
                class: _normalizeClass(_ctx.tileImageClasses(_ctx.value, _ctx.type))
              }, null, 2))
            : _createCommentVNode("", true),
          (_ctx.isImageVisible(64, 128, _ctx.types.hdd) && !_ctx.isAbsolute)
            ? (_openBlock(), _createElementBlock("img", {
                key: 79,
                src: _imports_79,
                class: _normalizeClass(_ctx.tileImageClasses(_ctx.value, _ctx.type))
              }, null, 2))
            : _createCommentVNode("", true),
          (_ctx.isImageVisible(128, 256, _ctx.types.hdd) && _ctx.isAbsolute)
            ? (_openBlock(), _createElementBlock("img", {
                key: 80,
                src: _imports_80,
                class: _normalizeClass(_ctx.tileImageClasses(_ctx.value, _ctx.type))
              }, null, 2))
            : _createCommentVNode("", true),
          (_ctx.isImageVisible(128, 256, _ctx.types.hdd) && !_ctx.isAbsolute)
            ? (_openBlock(), _createElementBlock("img", {
                key: 81,
                src: _imports_81,
                class: _normalizeClass(_ctx.tileImageClasses(_ctx.value, _ctx.type))
              }, null, 2))
            : _createCommentVNode("", true),
          (_ctx.isImageVisible(256, 512, _ctx.types.hdd) && _ctx.isAbsolute)
            ? (_openBlock(), _createElementBlock("img", {
                key: 82,
                src: _imports_82,
                class: _normalizeClass(_ctx.tileImageClasses(_ctx.value, _ctx.type))
              }, null, 2))
            : _createCommentVNode("", true),
          (_ctx.isImageVisible(256, 512, _ctx.types.hdd) && !_ctx.isAbsolute)
            ? (_openBlock(), _createElementBlock("img", {
                key: 83,
                src: _imports_83,
                class: _normalizeClass(_ctx.tileImageClasses(_ctx.value, _ctx.type))
              }, null, 2))
            : _createCommentVNode("", true),
          (_ctx.isImageVisible(512, 1024, _ctx.types.hdd) && _ctx.isAbsolute)
            ? (_openBlock(), _createElementBlock("img", {
                key: 84,
                src: _imports_84,
                class: _normalizeClass(_ctx.tileImageClasses(_ctx.value, _ctx.type))
              }, null, 2))
            : _createCommentVNode("", true),
          (_ctx.isImageVisible(512, 1024, _ctx.types.hdd) && !_ctx.isAbsolute)
            ? (_openBlock(), _createElementBlock("img", {
                key: 85,
                src: _imports_85,
                class: _normalizeClass(_ctx.tileImageClasses(_ctx.value, _ctx.type))
              }, null, 2))
            : _createCommentVNode("", true),
          (_ctx.isImageVisible(1024, 2048, _ctx.types.hdd) && _ctx.isAbsolute)
            ? (_openBlock(), _createElementBlock("img", {
                key: 86,
                src: _imports_86,
                class: _normalizeClass(_ctx.tileImageClasses(_ctx.value, _ctx.type))
              }, null, 2))
            : _createCommentVNode("", true),
          (_ctx.isImageVisible(1024, 2048, _ctx.types.hdd) && !_ctx.isAbsolute)
            ? (_openBlock(), _createElementBlock("img", {
                key: 87,
                src: _imports_87,
                class: _normalizeClass(_ctx.tileImageClasses(_ctx.value, _ctx.type))
              }, null, 2))
            : _createCommentVNode("", true),
          (_ctx.isAbsoluteTile())
            ? (_openBlock(), _createBlock(_component_tp_tile_blur_absolute, {
                key: 88,
                class: "tile-backgroud__blur-absolute",
                color: _ctx.color
              }, null, 8, ["color"]))
            : _createCommentVNode("", true),
          (!_ctx.isAbsoluteTile())
            ? (_openBlock(), _createBlock(_component_tp_tile_blur, {
                key: 89,
                class: "tile-backgroud__blur",
                color: _ctx.color
              }, null, 8, ["color"]))
            : _createCommentVNode("", true)
        ], 2),
        _hoisted_1,
        (_ctx.done === true)
          ? (_openBlock(), _createBlock(_component_tp_done, {
              key: 0,
              class: "tp-tile__done"
            }))
          : _createCommentVNode("", true),
        (!_ctx.isAbsolute && _ctx.isActive)
          ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.type.toUpperCase()), 1))
          : _createCommentVNode("", true)
      ], 2))
    : _createCommentVNode("", true)
}